import QRCode from "./component/qrcode.js";
import { LoginType } from "../commons/commonVariables";
import axios from "../api/axios.js";
import wx from "weixin-js-sdk";
import { Toast } from "vant";
import {
  getEnvMark,
  isAllLogin
} from "../page/vibrantRubikCube/runtime/common-methods/utils.js";
import { EnvMark } from "../page/vibrantRubikCube/runtime/lucky-draw/common/global-variable.js";
import { $memberMixSwitch } from "../api/config.js";

export default {
  getUrlParams() {
    try {
      let params = window.location.search.replace("?", '{"');
      params = params.replace("/", "");
      params = params + '"}';
      params = params.replace(/&&/g, "&");
      params = params.replace(/&/g, '","');
      params = params.replace(/=/g, '":"');
      params = JSON.parse(params);
      return params;
    } catch (error) {
      // console.log("url参数不是对象")
    }
  },

  //表格render下拉框通用，返回Option子集
  setDropData(h, sourceData, setting) {
    let list = [];
    for (let i = 0; sourceData && i < sourceData.length; i++) {
      const obj = sourceData[i];
      list.push(
        h("Option", {
          props: {
            value: obj.value || obj[setting.value],
            label: obj.label || obj[setting.label]
          }
        })
      );
    }
    return list;
  },
  //表格render复选框通用，返回Checkbox 子集
  setCheckboxData(h, sourceData, setting) {
    let list = [];
    for (let i = 0; sourceData && i < sourceData.length; i++) {
      const obj = sourceData[i];
      list.push(
        h(
          "Checkbox",
          {
            props: {
              label: obj.value || obj[setting.value]
            }
          },
          obj.label || obj[setting.label]
        )
      );
    }
    return list;
  },
  //表格render单选框通用,返回RadioGroup子集
  setRadioGroupData(h, sourceData, setting) {
    let list = [];
    for (let i = 0; sourceData && i < sourceData.length; i++) {
      const obj = sourceData[i];
      list.push(
        h(
          "Radio",
          {
            props: {
              label: obj.value || obj[setting.value]
            }
          },
          obj.label || obj[setting.label]
        )
      );
    }
    return list;
  },
  //表格CUD data拼接
  getTableDataCUD(tableData, isTree) {
    let items2Delete = [];
    let items2Create = [];
    let items2Update = [];
    //_changeStatus 0 删除、1 修改、2 新增 ；
    tableData.forEach(row => {
      //复制一份，删除table中私有属性
      let d = JSON.parse(JSON.stringify(row));
      if (
        (d._changeStatus === "0" && !d._changeStatusOld) ||
        (d._changeStatus === "0" && d._changeStatusOld != "2")
      ) {
        items2Delete.push(d);
      } else if (d._changeStatus === "1") {
        items2Update.push(d);
      } else if (d._changeStatus === "2") {
        items2Create.push(d);
      }
      delete d.cellClassName;
      delete d._index;
      delete d._changeStatus;
      if (isTree) delete d.children;
    });
    return { filter: { items2Delete, items2Create, items2Update } };
  },
  //表格行样式渲染，三合一表格使用
  rowClassName(row, index) {
    //changeStatus 0 删除、1 修改、2 新增 ；
    if (row._changeStatus === "0") {
      return "table-delete-row";
    } else if (row._changeStatus === "1") {
      return "table-update-row";
    } else if (row._changeStatus === "2") {
      return "table-add-row";
    } else {
      return "table-n-row";
    }
  },
  //生成树的数据
  setCacheNode(treeCfg, isCopy) {
    let cache = {};
    let root = [];
    let datas = treeCfg.data; //配置数据
    let checkbox = this.show - checkbox; //是否显示复选框
    let id = treeCfg.id; //节点唯一标识字段
    let pid = treeCfg.pid; //父节点字段
    let title = treeCfg.title;
    let rootId = treeCfg.rootId || "-1"; //根节点值
    for (var i = 0; i < datas.length; i++) {
      let item = datas[i];
      item.title = item[title];
      //默认不勾选
      if (checkbox && !item.checkbox) {
        item.checkbox = false;
      }
      cache[item[id]] = isCopy === false ? item : Object.assign({}, item);
    }

    for (var i = 0; i < datas.length; i++) {
      let item = cache[datas[i][id]];
      if (item[pid] === rootId) {
        root.push(item);
      } else {
        let pNode = cache[item[pid]];
        let children = pNode && pNode.children;
        if (children && children.length > 0) {
          children.push(item);
        } else if (pNode) {
          pNode.children = [item];
        } else {
          pNode = [item];
        }
      }
    }
    return root;
  },
  //设置一个cookies
  setCookie(name, value, days) {
    let d = new Date();
    let host = window.location.host;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    window.document.cookie =
      name +
      "=" +
      value +
      ";Domain=." +
      host +
      ";path=/;expires=" +
      d.toGMTString();
  },
  //获取一个cookie
  getCookie(name) {
    let strCookie = document.cookie;
    let arr = strCookie.split(";");
    for (let i = 0; i < arr.length; i++) {
      //避免参数中有多个等号
      let t = arr[i].replace("=", ";;");
      t = t.split(";;");
      if (t[0].trim() == name) {
        return t[1];
      }
    }
    return null;
  },
  //删除一个cookie
  delCookie(name) {
    let d = new Date();
    let host = window.location.host;
    d.setTime(d.getTime() - 1);
    let value = this.getCookie(name);
    if (value != null)
      window.document.cookie =
        name +
        "=" +
        value +
        ";Domain=." +
        host +
        ";path=/;expires=" +
        d.toGMTString();
  },
  //该方法接受一个数值 n 作为参数，并返回存储中的第 n 个键名。
  getStorageKey(n) {
    return window.localStorage.key(n);
  },
  /**
   * localStorage方法封装，该方法接受一个键名作为参数，返回键名对应的值。
   * @param {*} key 键名
   * @returns 存储的值
   */
  getStorageItem(key) {
    return window.localStorage.getItem(key);
  },
  /**
   * localStorage方法封装，根据键名查询本地缓存，并将获取的值转换成JSON对象
   * @param {*} key
   * @returns
   */
  getStorageItemObj(key) {
    try {
      const obj = JSON.parse(this.getStorageItem(key));
      return obj;
    } catch (error) {
      return null;
    }
  },
  //该方法接受一个键名和值作为参数，将会把键值对添加到存储中，如果键名存在，则更新其对应的值。
  setStorageItem(key, objStr) {
    window.localStorage.setItem(key, objStr);
  },
  setStorageItemObj(key, obj) {
    let objStr = JSON.stringify(obj);
    this.setStorageItem(key, objStr);
  },
  setStorageItemObjAllKey(obj) {
    for (let i in obj) {
      this.setStorageItem(i, obj[i]);
    }
  },
  //该方法接受一个键名作为参数，并把该键名从存储中删除。
  removeStorageItem(key) {
    window.localStorage.removeItem(key);
  },
  //返回数据类型
  getDataType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  },
  //变量类型
  toType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  },
  //校验是否是数字
  isNumber(value) {
    let reg = /^\-?[0-9]+\.?[0-9]*$/;
    return reg.test(value);
  },
  //校验是否是对象
  isObject(obj) {
    return this.toType(obj) === "object";
  },
  //判断是否是空对象
  isEmptyObject(obj) {
    if (this.isObject(obj)) {
      //如果是空对象返回true
      if (Object.keys(obj).length === 0) {
        return true;
      }
      return false;
    }
    return "notIsObject";
  },
  isValueNumber(value) {
    return /^[1-9][0-9]*$/.test(value + "");
  },
  isArray(obj) {
    return this.toType(obj) === "array";
  },
  isString(value) {
    return typeof value === "string";
  },
  isFunction(fn) {
    return this.toType(fn) === "function";
  },
  /**
   * 判断是否为空值，null、undefined、无内容字符串都返回true
   * @param {string} value
   * @returns {boolean|*}
   */
  isNullOrEmpty(value) {
    return (
      value === null ||
      value === undefined ||
      (this.toType(value) === "string" && value.trim().length === 0)
    );
  },
  /**
   * 计算字符串长度或所占的内存字节数。
   * 默认计算方式（中文算两个长度，数字字母算一个），也可指定为 'basic','UTF-16','UTF-8',或自定义的计算规则。
   *
   *     getLength('12ED'); // => 4
   *     getLength('深圳'); // => 4
   *     getLength('好a','basic'); // '好a' => 2，'a' => 1
   *     getLength('好a','UTF-8'); // 好a' => 4，'a' => 1
   *     getLength('好a','UTF-16'); //'好a' => 4，'a' => 2
   *     getLength(str, function(str) {
   *		   return (str + 'xx').length;
   *     });
   * UTF-8 是一种可变长度的 Unicode 编码格式，使用一至四个字节为每个字符编码
   *
   *     000000 - 00007F(128个代码)      0zzzzzzz(00-7F)                             一个字节
   *     000080 - 0007FF(1920个代码)     110yyyyy(C0-DF) 10zzzzzz(80-BF)             两个字节
   *     000800 - 00D7FF 注: Unicode在范围 D800-DFFF 中不存在任何字符
   *     00E000 - 00FFFF(61440个代码)    1110xxxx(E0-EF) 10yyyyyy 10zzzzzz           三个字节
   *     010000 - 10FFFF(1048576个代码)  11110www(F0-F7) 10xxxxxx 10yyyyyy 10zzzzzz  四个字节
   *
   *
   * 定义参考 http://zh.wikipedia.org/wiki/UTF-8
   *
   * UTF-16 大部分使用两个字节编码，编码超出 65535 的使用四个字节
   *
   *     000000 - 00FFFF  两个字节
   *     010000 - 10FFFF  四个字节
   *
   * 定义参考  http://zh.wikipedia.org/wiki/UTF-16
   * @param  {String} str
   * @param  {String | Function} lengthRegular 'basic','UTF-16','UTF-8',或自定义的计算规则
   * @return {Number} count 字符串长度
   * @member Utils.String
   */
  getLength: function(str, lengthRegular) {
    if (!this.isString(str) || str.length === 0) {
      return 0;
    }
    var count = 0,
      charCode,
      i,
      len;

    if (this.isString(lengthRegular)) {
      lengthRegular = lengthRegular.toLowerCase();
      if (lengthRegular === "utf-16" || lengthRegular === "utf16") {
        for (i = 0, len = str.length; i < len; i++) {
          charCode = str.charCodeAt(i);
          if (charCode <= 0xffff) {
            count += 2;
          } else {
            count += 4;
          }
        }
      } else if (lengthRegular === "utf-8" || lengthRegular === "utf8") {
        for (i = 0, len = str.length; i < len; i++) {
          charCode = str.charCodeAt(i);
          if (charCode <= 0x007f) {
            count += 1;
          } else if (charCode <= 0x07ff) {
            count += 2;
          } else if (charCode <= 0xffff) {
            count += 3;
          } else {
            count += 4;
          }
        }
      } else {
        //return str.length;
        // '\uD83D\uDCA9' => 1 // 匹配UTF-16的代理对
        return str.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "_").length;
      }
    } else if (this.isFunction(lengthRegular)) {
      return lengthRegular(str);
    } else {
      for (i = 0; i < str.length; i++) {
        count++;
        if (str.charCodeAt(i) >> 8) {
          count++;
        }
      }
    }
    return count;
  },
  //给表单字段赋值 isForced 是否为空也替换
  getFormAttrValue(formObj, dataObj, isForced) {
    let obj = Object.assign({}, dataObj);
    for (let i in formObj) {
      if (obj[i] === undefined) {
        continue;
      }
      if (this.toType(obj[i]) == "number" && obj[i] == 0) obj[i] = "0";
      formObj[i] = isForced ? obj[i] : obj[i] || formObj[i];
    }
  },
  /**
   * 拼接图片完整url
   * @param {string} url 从接口返回的file字段，如"marking/upload/2023-06-02/7cc29ccea234436f941d887e5bb999d8.png"
   * @returns 图片完整URL
   */
  getImageUrl(url, type = "image") {
    if (url && url.indexOf("https://") > -1) {
      return url;
    }
    let interfaceUrl = "";
    if (type === "image") {
      interfaceUrl = "/mobileZuul/integration/spuImage/image?url=";
    }
    if (type === "video") {
      interfaceUrl = "/mobileZuul/integration/spuImage/mp4video?url=";
    }
    if (url) {
      return window.location.origin + interfaceUrl + url;
    } else {
      return window.location.origin + interfaceUrl;
    }
  },
  //文件流转base64位编码
  fileReader(files, bData) {
    let self = this;
    // 看支持不支持FileReader
    if (!window.FileReader) return;
    if (files.length > 0) {
      let pList = [];
      for (let i = 0; i < files.length; i++) {
        pList.push(
          new Promise(function(resolve, reject) {
            let filesObj = {
              fileName: files[i].name
            };
            let reader = new FileReader();
            reader.onloadend = function() {
              filesObj.file = this.result;
              resolve(filesObj);
            };
            reader.readAsDataURL(files[i]);
          })
        );
      }
      // Promise.all(pList).then((files)=>{
      //     bData=files[0].file
      // },null)
      return pList;
    }
  },
  //图片文件转换为64位编码
  readerImg(fileItem) {
    let self = this;
    let imgObj = {};
    let reader = new FileReader();
    // 这里是最关键的一步，转换就在这里
    reader.readAsDataURL(fileItem);
    reader.onloadend = function() {
      imgObj.src = this.result;
      return imgObj;
    };
  },
  //对象和数组深度复制
  deepCopy(data) {
    const t = this.toType(data);
    let o;
    if (t === "array") {
      o = [];
    } else if (t === "object") {
      o = {};
    } else {
      return data;
    }
    if (t === "array") {
      for (let i = 0; i < data.length; i++) {
        o.push(this.deepCopy(data[i]));
      }
    } else if (t === "object") {
      for (let i in data) {
        o[i] = this.deepCopy(data[i]);
      }
    }
    return o;
  },
  //生成二维码，el:生成二维码的放置dom元素，二维码设置
  qrcode(el, cfg) {
    let q = QRCode.initQrcode();
    cfg = Object.assign(
      {
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: q.CorrectLevel.H
      },
      cfg
    );
    let qrcode = new q(el, cfg);
    return qrcode;
  },
  encryptionCom(str, bNumb, eNumb) {
    if (str === null || str === undefined) return str;
    bNumb = bNumb || 0;
    eNumb = eNumb || 0;
    let eStr = str,
      eLength = eStr.length - bNumb - eNumb;
    if (eLength > 0) {
      let rep = "*".repeat(eLength);
      eStr = eStr.slice(0, bNumb) + rep + (eNumb ? eStr.slice(-eNumb) : "");
    }
    return eStr;
  },
  /**
   * 私隐加密
   * type:name 姓名,phone 电话,longStr 长字符 通常前三、后四显示
   */
  encryption(str, type) {
    let eStr = str;
    if (type == "name") {
      eStr = this.encryptionCom(eStr, 1);
    } else if (type == "phone") {
      eStr = this.encryptionCom(eStr, 3, 4);
    } else {
      eStr = this.encryptionCom(eStr, 3, 4);
    }
    return eStr;
  },
  /**
   * 生成一个guid。
   * @param {String} prefix guid前缀
   * @param {Number} [length] 生成的guid前缀
   * @returns {String}
   */
  getGuid: function(prefix, length) {
    return (
      (prefix || "") +
      Math.random()
        .toString()
        .substr(2, length || 8)
    );
  },
  /**
   * 生成一个符合RFC4122标准的全局唯一ID，形如 e2ece964-0315-4b91-b411-20f9868ce7d4
   * @returns {string}
   */
  getuid: function() {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  //通用复制字符串到剪切板
  copyText(str) {
    let isRTL = document.documentElement.getAttribute("dir") == "rtl";
    let fakeElem = document.createElement("textarea");
    fakeElem.style.fontSize = "12pt";
    fakeElem.style.border = "0";
    fakeElem.style.padding = "0";
    fakeElem.style.margin = "0";
    // Move element out of screen horizontally
    fakeElem.style.position = "absolute";
    fakeElem.style[isRTL ? "right" : "left"] = "-9999px";
    // Move element to the same position vertically
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    fakeElem.style.top = yPosition + "px";
    fakeElem.setAttribute("readonly", "");
    fakeElem.value = str;

    document.body.appendChild(fakeElem);
    fakeElem.select();
    fakeElem.setSelectionRange(0, fakeElem.value.length);
    document.execCommand("copy");
    return fakeElem;
  },
  //判断当前是否为微信环境
  isWxBrowser() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  },
  /**
   * 表格数据显示匿名值方法
   * @param {List} list 表格显示数据
   * @param {List} keys 需要转换匿名值的数组 列如：['ahsRequestBodyVo','dataImei1Vo']
   * @returns {List} 返回最新数组
   */
  addAnonymizedText(list, keys) {
    list.forEach(item => {
      keys.forEach(key => {
        item[key] = item[key] ? item[key].anonymizedText : "";
      });
    });
    return list;
  },
  /**
   * 表格查询条件增加隐私结构体方法
   * @param {Object} Vo 表格显示数据
   * @param {Object} keys 需要转换匿名值对象 列如：{'productImei':'$ImeiPrivacyHash$'}
   * @returns {Object} 返回最新的查询对象
   */
  utilAddPrivacyStructure(Vo, keys) {
    Object.keys(Vo).forEach(key => {
      if (keys[key] && Vo[key]) {
        Vo[key] = {
          opt: keys[key],
          plainText: Vo[key]
        };
      }
    });
    return Vo;
  },
  /**
   * 详情页面恢复匿名值隐私信息
   * @param {Object} keys 需要转换匿名值对象 列如：{'productImei':'$ImeiPrivacyHash$'}
   * @param {Object} sourceVo 拷贝的原始对象用来从原文改成匿名值的对象
   * @param {Object} optVo 页面显示的操作对象
   * @returns {Null}
   */
  restorePrivacy(keys, sourceVo, optVo) {
    if (sourceVo && optVo) {
      Object.keys(keys).forEach(key => {
        if (sourceVo[key] && optVo[key]) {
          optVo[key] = sourceVo[key].anonymizedText;
        }
      });
    }
  },
  //隐私信息保存
  privacySave(keys, keyList, sourceVo, isImei) {
    //如果源对象和操作对象为空则不往下执行
    if (!sourceVo) return false;
    keyList.forEach(key => {
      Object.keys(keys).forEach(value => {
        if (sourceVo[value] && value == key[value]) {
          sourceVo[value] = {
            bizObjectId: key.labelText, //字段名
            channelId: "872cc0ff763db3950176427d145b0332", //固定
            userId: "", //非必填   取登录人
            type: key.typeText, //隐私类型，要xml对应
            bizObjectType: "OTHER", //固定
            opt: isImei ? "$ImeiPrivacySensitized$" : "$PrivacySensitized$", //固定
            plainText: sourceVo[value] //明文
          };
        }
      });
    });
  },
  // 图片压缩方法
  dealImage(base64, w, callBack) {
    console.log("图片压缩");
    let newImage = new window.Image();
    //压缩系数0-1之间
    let quality = 0.6;
    newImage.src = base64;
    newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
    var imgWidth, imgHeight;
    newImage.onload = function() {
      imgWidth = this.width;
      imgHeight = this.height;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      if (Math.max(imgWidth, imgHeight) > w) {
        if (imgWidth > imgHeight) {
          canvas.width = w;
          canvas.height = (w * imgHeight) / imgWidth;
        } else {
          canvas.height = w;
          canvas.width = (w * imgWidth) / imgHeight;
        }
      } else {
        canvas.width = imgWidth;
        canvas.height = imgHeight;
        quality = 0.6;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
      var ba = canvas.toDataURL("image/jpeg", quality); //压缩语句
      callBack(ba);
    };
  },

  /**
   * 埋码上报，actionCode actionName content
   * @param {Object} that 当前上下文（可不填）
   * @param {Object} data 上报内容
   */
  handleBatchReport(that, data) {
    // 由于微信端 url 不支持中文  页面里写英文 上报转为中文
    const parentPageTemp = data.content.parentPage;
    switch (parentPageTemp) {
      case "customForm_commonForm":
        data.content.parentPage = "自定义表单-普通表单";
        break;
      case "activityOrchestration":
        data.content.parentPage = "活动编排";
        break;
      case "storeNavigation":
        data.content.parentPage = "门店导航";
        break;
      case "pictureFloor":
        data.content.parentPage = "图片楼层";
        break;
      case "thematicActivity":
        data.content.parentPage = "专题活动";
        break;
      case "customForm_topicForm":
        data.content.parentPage = "自定义表单-话题表单";
        break;
      case "customForm_interestForm":
        data.content.parentPage = "自定义表单-趣味表单";
        break;
      case "bigTurntable":
        data.content.parentPage = "大转盘";
        break;
      default:
        break;
    }
    // tid 获取逻辑，有效期为7天，若没有tid则生成一个，值为当前的时间戳，有的话直接使用已有的tid
    const INVALIDATION_TIME = 168 * 60 * 60 * 1000;
    const nowDate = new Date().getTime();
    let dapTID = sessionStorage.getItem("dapTID") || 0;
    let tid = 0;
    if (!dapTID || nowDate - dapTID >= INVALIDATION_TIME) {
      sessionStorage.setItem("dapTID", nowDate);
      tid = nowDate;
    } else {
      tid = dapTID;
    }

    // unionId 获取逻辑，根据登录类型取微信或支付宝的用户id，若没有则为空字符串
    const loginType = sessionStorage.getItem("loginType") || "";
    const userUnionid = sessionStorage.getItem("userUnionid") || "";
    const alipayUserId = sessionStorage.getItem("alipayUserId") || "";
    let unionId = loginType == "wechat" ? userUnionid : alipayUserId;
    unionId = unionId == "undefined" ? "" : unionId;

    // uid 用户登录ID (memberId)
    let uid = "";
    try {
      if (sessionStorage.getItem("userInfo")) {
        uid = JSON.parse(sessionStorage.getItem("userInfo")).memberCenterId;
      }
    } catch (e) {
      console.log("埋码上报，uid获取失败", e);
      uid = "";
    }

    // wi，导流商子信息
    let wi = sessionStorage.getItem("wi") || "";
    wi = wi == "undefined" ? "" : wi;

    // cpsId，导流商标识
    let cpsId = sessionStorage.getItem("cpsId") || "";
    cpsId = cpsId == "undefined" ? "" : cpsId;

    // dc，7 微信公众号; 8 支付宝生活号
    const dc = loginType == "wechat" ? 7 : 8;

    // passwd - 小程序口令
    const passwd = sessionStorage.getItem("passwd");

    // 组装 params
    let params = {
      actionCode: "",
      at: 40, //接入类型。取值范围：0-9 WAP，10-19 APP，20 PC，APP默认传10，WAP默认传0；WEB默认传20，小程序默认传40
      tid: tid,
      content: {},
      ln: navigator.language,
      ac: "HihonorMp",
      actionName: "",
      dc: dc
    };
    if (data.ac) params.ac = data.ac;
    if (unionId) params.unionId = unionId;
    if (uid) params.uid = uid;
    if (wi) params.wi = wi;
    if (cpsId) params.cpsId = cpsId;

    params = Object.assign(params, data);
    if (passwd) params.content.passwd = passwd;

    params = JSON.stringify([params]);

    // 发起请求，后台调用的是DAP的批量上报接口：dap/batchReport
    axios.post({
      noLoading: true,
      notFilterNull: true,
      sc: "",
      url: "mobileZuul/integration/buriedCodeManage/process",
      params: params,
      headers: {
        "Content-Type": "text/plain"
      }
    });
  },

  /**
   * 拼接参数到URL的尾部，拼接格式为hdmain?&<params.key>=<params.value>
   * @param {object} params
   */
  appendParamsToURL(params) {
    let res = "";
    // 只能传入对象
    if (Object.prototype.toString.call(params) === "[object Object]") {
      Object.keys(params).forEach(key => {
        res += `&${key}=${params[key]}`;
      });
    }
    return `/hdmain?${res}`;
  }
};

/**
 * 对象字段过滤，去除无效字段,对象字段支持：基本类型，数组（数组元素为基本类型才能有效进行过滤），嵌套对象
 * @param {Object} obj
 * @returns 过滤后返回一个新对象
 */
export function filterInvalidField(obj) {
  const res = {};
  Object.keys(obj).forEach(key => {
    const curValue = obj[key];
    if (curValue === null || curValue === undefined) {
      // null，undefined 不进行字段添加操作
    } else if (typeof curValue !== "object") {
      // 基本类型，且不为空串直接赋值
      if (String(curValue).trim().length !== 0 && curValue !== "undefined") {
        res[key] = curValue;
      }
    } else if (Array.isArray(curValue)) {
      // 数组，过滤掉空值
      res[key] = curValue.filter(item => {
        return (
          item !== null &&
          item !== undefined &&
          item !== "" &&
          item !== "undefined"
        );
      });
    } else {
      // 对象，进行递归
      res[key] = filterInvalidField(curValue);
    }
  });
  return res;
}

/**
 * 全部登录类型处理，根据所处环境，转换为对应登录类型
 * @param {String} loginType 登录类型
 * @returns
 */
export function AllLoginTypeHandler(loginType) {
  if (loginType && isAllLogin(loginType)) {
    const envMark = getEnvMark();
    if (window.location.host.includes("localhost")) {
      // 本地环境，转换为微信登录
      return LoginType.Wechat;
    } else if (envMark === EnvMark.wechatH5 || envMark === EnvMark.wechatMp) {
      // 微信环境
      return LoginType.Wechat;
    } else if (envMark === EnvMark.alipayH5 || envMark === EnvMark.alipayMp) {
      // 支付宝环境
      return LoginType.Alipay;
    } else if (envMark === EnvMark.otherBrowser) {
      // 浏览器场景，转换为微信登录
      return LoginType.Wechat;
    }
  } else {
    // 不是全部登录类型，则返回原值
    return loginType;
  }
}
/**
 * 加载支付宝小程序webView SDK
 * @returns
 */
export function loadAlipayWebViewScript() {
  return new Promise(resolve => {
    let url = "https://appx/web-view.min.js";
    let s = document.createElement("script");
    s.type = "text/javascript";
    if (s.readyState) {
      // IE
      s.onreadystatechange = function() {
        if (s.readyState === "loaded" || s.readyState === "complete") {
          s.onreadystatechange = null;
          resolve(true);
        }
      };
    } else {
      // 其他浏览器
      s.onload = function() {
        resolve(true);
      };
    }
    s.src = url;
    document.body.appendChild(s);
  });
}

/**
 * 加载Alipay JSSDK （支付宝登录需要加载）
 * @returns
 */
export function loadAlipayJsapiScript() {
  return new Promise(resolve => {
    const self = this;
    const url =
      "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js";
    const s = document.createElement("script");
    s.type = "text/javascript";
    if (s.readyState) {
      // IE
      s.onreadystatechange = function() {
        if (s.readyState === "loaded" || s.readyState === "complete") {
          s.onreadystatechange = null;
          resolve(true);
        }
      };
    } else {
      // 其他浏览器
      s.onload = function() {
        resolve(true);
      };
    }
    s.src = url;
    document.body.appendChild(s);
  });
}

/**
 * 微信用户登录
 * @param {String} wxLoginCode 微信登录code
 * @returns
 */
export function wxUserLogin(wxLoginCode) {
  return new Promise((resolve, reject) => {
    if (wxLoginCode) {
      Toast.loading({
        message: "登录中...",
        forbidClick: true,
        duration: 0
      });
      const sc = $memberMixSwitch ? "mobileWxMix" : "mobileWx";
      const url = $memberMixSwitch
        ? "quicklogin"
        : `getsession?code=${wxLoginCode}`;
      const headers = $memberMixSwitch
        ? {
            "content-type": "application/json",
            accept: "application/json;charset=UTF-8"
          }
        : { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" };
      const params = $memberMixSwitch ? { code: wxLoginCode } : "";
      axios.post({
        noLoading: true,
        sc: sc,
        url: url,
        params: params,
        headers: headers,
        success: r => {
          Toast.clear();
          // 针对code过期场景，进行处理
          const isFailed = $memberMixSwitch ? r.code !== "666666" : !r.data;
          if (isFailed) {
            reject(r.message || "登录失败，请刷新后重试。");
            return;
          }
          const userUnionid = (r.data && r.data.unionid) || "";
          const userOpenid = (r.data && r.data.openid) || "";
          const accessToken = (r.data && r.data.accessToken) || "";
          const userToken = (r.data && r.data.usertoken) || "";
          const memberCenterId = (r.data && r.data.memberId) || "";
          const member = memberCenterId ? true : false;
          const userObj = {
            openId: userOpenid,
            unionid: userUnionid,
            accessToken: accessToken,
            userToken: userToken,
            memberCenterId: memberCenterId,
            member: member
          };
          updateUserInfoCache(userObj);
          resolve(userObj);
        },
        failure: () => {
          Toast.clear();
          reject("登录失败，请刷新后重试。");
        }
      });
    } else {
      reject("未登录，请刷新后重试。");
    }
  });
}

/**
 * 更新用户信息缓存，传入的对象不为空，则更新对应的session缓存；否则清空对应的session缓存
 * @param {Object} userObj 用户信息对象
 */
export function updateUserInfoCache(
  userObj = null,
  loginType = LoginType.Wechat
) {
  if (userObj && Object.keys(userObj).length > 0) {
    sessionStorage.setItem("userInfo", JSON.stringify(userObj) || "");
    sessionStorage.setItem("userOpenid", userObj.openId || "");
    sessionStorage.setItem("accessToken", userObj.accessToken || "");
    sessionStorage.setItem("userToken", userObj.userToken || "");
    // 是否是会员
    sessionStorage.setItem("isMemberId", userObj.member || "false");
    // 根据登录类型缓存不同的字段
    if (loginType === LoginType.Wechat) {
      sessionStorage.setItem("userUnionid", userObj.unionid || "");
    } else if (loginType === LoginType.Alipay) {
      sessionStorage.setItem("alipayUserId", userObj.unionid || "");
    }
  } else {
    sessionStorage.setItem("userInfo", "{}");
    sessionStorage.setItem("userUnionid", "");
    sessionStorage.setItem("alipayUserId", "");
    sessionStorage.setItem("userOpenid", "");
    sessionStorage.setItem("accessToken", "");
    sessionStorage.setItem("userToken", "");
    sessionStorage.setItem("isMemberId", "false");
  }
}

export function goIdentityVerification(loginType, activityUrl) {
  const envMark = getEnvMark();
  console.log("环境判断", envMark);
  if (loginType === LoginType.Alipay) {
    //在支付宝小程序环境打开
    if (envMark === EnvMark.alipayMp) {
      console.log("支付宝小程序1--activityUrl", activityUrl);
      loadAlipayWebViewScript().then(() => {
        my.postMessage({
          activityUrl: encodeURIComponent(activityUrl)
        });
        my.reLaunch({
          url:
            "/subpackages/index/pages/identityCertification/identity-certification?activityUrl=" +
            encodeURIComponent(activityUrl),
          success: res => {
            console.log("h5跳转支付宝小程序成功res", res);
          },
          fail: err => {
            console.log("h5跳转支付宝小程序失败err", err);
          }
        });
      });
    } else if (envMark === EnvMark.alipayH5) {
      //在支付宝内部浏览器打开
      const query = encodeURIComponent(`activityUrl=${activityUrl}`);
      console.log("支付宝小程序2query", query);
      window.location.href =
        "alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/index/pages/identityCertification/identity-certification&query=" +
        query;
    }
  } else if (loginType === LoginType.Wechat && envMark === EnvMark.wechatMp) {
    wx.miniProgram.postMessage({
      activityUrl: encodeURIComponent(activityUrl)
    });
    wx.miniProgram.reLaunch({
      url:
        "/subpackages/index/pages/identityCertification/identity-certification?activityUrl=" +
        encodeURIComponent(activityUrl),
      success: res => {
        console.log("h5跳转微信小程序成功res", res);
      },
      fail: err => {
        console.log("h5跳转微信小程序失败err", err);
      }
    });
  }
}

/**
 * 对象字段过滤，去除无效字段,对象字段支持：基本类型，数组（数组元素为基本类型才能有效进行过滤），嵌套对象
 * @returns 过滤后返回一个新对象
 */
export function getUrlParams() {
  try {
    let params = window.location.search.replace("?", '{"');
    params = params.replace("/", "");
    params = params + '"}';
    params = params.replace(/&&/g, "&");
    params = params.replace(/&/g, '","');
    params = params.replace(/=/g, '":"');
    params = JSON.parse(params);
    return params;
  } catch (error) {
    // console.log("url参数不是对象")
  }
}



// WEBPACK FOOTER //
// ./src/utils/comUtils.js